var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.93 32.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-linejoin:round;}.cls-1,.cls-2{stroke:#81A235;stroke-linecap:round;stroke-width:1.1px;}.cls-2{fill:#9bd2fa;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.01,
    y: 16.45,
    width: 17.01,
    height: 1.55,
    rx: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.01,
    y: 7.73,
    width: 17.01,
    height: 1.56,
    rx: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.51,
    y1: 25.16,
    x2: 11.51,
    y2: 26.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.55,
    y1: 29.13,
    x2: 9,
    y2: 29.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.93,
    y1: 29.13,
    x2: 22.38,
    y2: 29.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.93,29.2a2.42,2.42,0,1,0-2.42,2.42A2.42,2.42,0,0,0,13.93,29.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.59,18H1.43a.49.49,0,0,0-.48.49v6.19a.48.48,0,0,0,.48.48H21.59a.48.48,0,0,0,.49-.48V18.49A.49.49,0,0,0,21.59,18Zm-3.37,5.05a1.4,1.4,0,1,1,1.39-1.39A1.39,1.39,0,0,1,18.22,23.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.59,9.28H1.43A.48.48,0,0,0,1,9.76V16a.49.49,0,0,0,.48.49H21.59a.49.49,0,0,0,.49-.49V9.76A.48.48,0,0,0,21.59,9.28Zm-3.37,4.93a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,18.22,14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.59.55H1.44A.49.49,0,0,0,1,1V7.22a.49.49,0,0,0,.48.49H21.59a.49.49,0,0,0,.49-.49V1A.49.49,0,0,0,21.59.55Zm-3.37,5a1.39,1.39,0,1,1,1.39-1.39A1.39,1.39,0,0,1,18.22,5.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.63,
    y: 4.04,
    width: 0.35,
    height: 0.35,
    transform: "translate(15.62 8.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.23,
    y: 4.04,
    width: 0.35,
    height: 0.35,
    transform: "translate(8.81 8.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.63,
    y: 12.74,
    width: 0.35,
    height: 0.35,
    transform: "translate(15.62 25.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.23,
    y: 12.74,
    width: 0.35,
    height: 0.35,
    transform: "translate(8.81 25.83) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.63,
    y: 21.61,
    width: 0.35,
    height: 0.35,
    transform: "translate(15.62 43.57) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.23,
    y: 21.61,
    width: 0.35,
    height: 0.35,
    transform: "translate(8.81 43.57) rotate(180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIe);
export default __webpack_public_path__ + "static/media/ie.8e1a2d9fa1635aa59b0ea271141e565c.svg";
export { ForwardRef as ReactComponent };